import { render, staticRenderFns } from "./Release.vue?vue&type=template&id=fd993ae0&scoped=true&"
import script from "./Release.vue?vue&type=script&lang=js&"
export * from "./Release.vue?vue&type=script&lang=js&"
import style0 from "./Release.vue?vue&type=style&index=0&id=fd993ae0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd993ae0",
  null
  
)

export default component.exports